import { Instagram, Twitter, Youtube, Facebook, Rocket } from "lucide-react";

const Footer = ({ settings }) => {
  const s = settings || {};
  return (
    <footer id="contact" className="mt-24 border-t border-white/5 pb-28">
      <div className="mx-auto grid max-w-[1400px] gap-10 px-4 py-16 sm:px-6 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="font-[Unbounded,sans-serif] text-3xl font-bold uppercase tracking-tight text-[#FAFAFA]">
            Black Box Music
          </div>
          <p className="mt-4 max-w-md font-mono text-base font-bold leading-relaxed text-[#FAFAFA]">
            Black Box Music — an artist-first music platform and label powered by $BBM, a utility token for access, rewards, governance, and creator payouts.
          </p>
        </div>
        <div>
          <div className="font-mono text-sm font-bold uppercase tracking-[0.22em] text-[#A855F7]">Contact</div>
          <a
            href={`mailto:${s.contact_email || "hello@blackboxmusic.com"}`}
            data-testid="footer-contact-email"
            className="mt-3 block font-mono text-base font-bold text-[#FAFAFA] transition-colors hover:text-[#A855F7]"
          >
            {s.contact_email || "hello@blackboxmusic.com"}
          </a>
        </div>
        <div>
          <div className="font-mono text-sm font-bold uppercase tracking-[0.22em] text-[#A855F7]">Follow</div>
          <div className="mt-3 flex flex-col gap-2 font-mono text-base font-bold">
            <a
              href="https://youtube.com/@blackboxmusic41?si=CpCwF8j5zj46fP9K"
              target="_blank"
              rel="noreferrer"
              data-testid="footer-social-youtube"
              className="flex items-center gap-2 text-[#FAFAFA] hover:text-[#A855F7]"
            >
              <Youtube size={16} /> YouTube
            </a>
            <a
              href="https://www.instagram.com/blackboxmusic2025?utm_source=qr"
              target="_blank"
              rel="noreferrer"
              data-testid="footer-social-instagram"
              className="flex items-center gap-2 text-[#FAFAFA] hover:text-[#A855F7]"
            >
              <Instagram size={16} /> Instagram
            </a>
            <a
              href="https://www.facebook.com/share/18yEkSFdHZ/?mibextid=wwXIfr"
              target="_blank"
              rel="noreferrer"
              data-testid="footer-social-facebook"
              className="flex items-center gap-2 text-[#FAFAFA] hover:text-[#A855F7]"
            >
              <Facebook size={16} /> Facebook
            </a>
            <a
              href="https://pump.fun/coin/CXo4dUwJw6D2m4ELeXZfyNnro4bc8sJJ4WtGcxAipump"
              target="_blank"
              rel="noreferrer"
              data-testid="footer-social-pumpfun"
              className="flex items-center gap-2 text-[#FAFAFA] hover:text-[#A855F7]"
            >
              <Rocket size={16} /> pump.fun / $BBM
            </a>
            {s.social_instagram ? (
              <a href={s.social_instagram} target="_blank" rel="noreferrer" data-testid="footer-social-instagram-cms" className="flex items-center gap-2 text-[#FAFAFA] hover:text-[#A855F7]">
                <Instagram size={16} /> Instagram
              </a>
            ) : null}
            {s.social_twitter ? (
              <a href={s.social_twitter} target="_blank" rel="noreferrer" data-testid="footer-social-twitter" className="flex items-center gap-2 text-[#FAFAFA] hover:text-[#A855F7]">
                <Twitter size={16} /> Twitter
              </a>
            ) : null}
            {s.social_soundcloud ? (
              <a href={s.social_soundcloud} target="_blank" rel="noreferrer" data-testid="footer-social-soundcloud" className="text-[#FAFAFA] hover:text-[#A855F7]">
                Soundcloud
              </a>
            ) : null}
            {s.social_mixcloud ? (
              <a href={s.social_mixcloud} target="_blank" rel="noreferrer" data-testid="footer-social-mixcloud" className="text-[#FAFAFA] hover:text-[#A855F7]">
                Mixcloud
              </a>
            ) : null}
            {!s.social_instagram && !s.social_twitter && !s.social_soundcloud && !s.social_mixcloud ? null : null}
          </div>
        </div>
      </div>
      <div className="mx-auto flex max-w-[1400px] items-center justify-between border-t border-white/5 px-4 py-6 font-mono text-sm font-bold uppercase tracking-[0.22em] text-[#A1A1AA] sm:px-6">
        <span>© {new Date().getFullYear()} Black Box Music</span>
        <span>24/7 // Live</span>
      </div>
    </footer>
  );
};

export default Footer;
